import axios from "axios";
import Vue from "vue";
const prefsKey = "prefs";

export default {
	namespaced: true,
	state: {
		settings: {
			articles: [],
		},
		loaded: false,

		settingsAll: null,
		loadedAll: false,
		prefs: {
			country_code: "CA",
			country_name: "Canada",
			rsm_connecting_stripe: true,
			merchant_subscription: true,
		},
	},
	actions: {
		loadSettings(ctx, {code}) {
			return axios
				.get(`/api/v1/management/homepage/?code=${code}`)
				.then((r) => {
					ctx.commit("setSettings", r.data);
					return r;
				})
				.catch((e) => {
					Vue.$toasted.error(`Fail to load settings: ${e}`);
				});
		},

		loadSettingsAll({commit}) {
			return axios
				.get("/api/v1/management/homepage/all")
				.then((r) => {
					commit("setSettingsAll", r.data);
					return r;
				})
				.catch((e) => {
					Vue.$toasted.error(`Fail to load settings all: ${e}`);
				});
		},
	},
	getters: {
		getLoaded(state) {
			return state.loaded;
		},
		getSettings(state) {
			return state.settings;
		},
		getSettingsAll(state) {
			return state.settingsAll;
		},
		getLoadedAll(state) {
			return state.loadedAll;
		},
		getPrefs(state) {
			return state.prefs;
		},
	},
	mutations: {
		setSettings(state, value) {
			state.settings = value;
			state.loaded = value != null;
		},
		setSettingsAll(state, value) {
			state.settingsAll = value;
			state.loadedAll = value != null;
		},
		setPrefs(state, value) {
			state.prefs = value;
			sessionStorage.setItem(prefsKey, JSON.stringify(value));
		},
	},
};
